import { plural } from '@cian/utils/lib/shared/plural';
import { shortenNumber } from '@cian/utils/lib/shared/shorten_number';
import * as React from 'react';

import { IRoomInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Link } from '../../../common/components/link';

import * as Analytics from '../tracking';

import * as styles from './index.css';

const roomTypeLocale: {
  [index: string]: string;
} = {
  bed: 'Койко-место',
  fiveRoom: '5-комн.',
  fourRoom: '4-комн.',
  large: 'Многокомн.',
  oneRoom: '1-комн.',
  openPlan: 'Своб. план.',
  room: 'Комната',
  share: 'Доля',
  studio: 'Студия',
  threeRoom: '3-комн.',
  twoRoom: '2-комн.',
};

interface IRoomInforProps {
  info: IRoomInfoSchema;
}

export class RoomInfo extends React.PureComponent<IRoomInforProps, {}> {
  public render() {
    const { info } = this.props;

    if (!info.type) {
      return null;
    }

    return (
      <li className={styles['row']}>
        <span className={styles['cell']}>
          {renderType(info.type)}
          {renderMinArea(info)}
        </span>
        <span className={styles['cell']}>{renderPrice(info)}</span>
        {renderOffersCount(info)}
      </li>
    );
  }
}

function renderType(type: string) {
  return `${roomTypeLocale[type]}`;
}

function renderMinArea(info: IRoomInfoSchema) {
  if (!info.minArea) {
    return null;
  }

  return ` от\xa0${info.minArea.toString().replace('.', ',')}\xa0м\u00B2`;
}

function renderPrice(info: IRoomInfoSchema): string | null {
  if (info.minPrice && !info.maxPrice) {
    return `от ${shortenNumber(info.minPrice, { separator: ',' })}`;
  }

  if (info.maxPrice && !info.minPrice) {
    return `до ${shortenNumber(info.maxPrice, { separator: ',' })}`;
  }

  if (info.minPrice && info.maxPrice) {
    return `${shortenNumber(info.minPrice, {
      billionPostfix: '',
      millionPostfix: '',
      separator: ',',
      thousandPostfix: '',
    })} - ${shortenNumber(info.maxPrice, { separator: ',' })}`;
  }

  return null;
}

function renderOffersCount(info: IRoomInfoSchema) {
  if (!info.offersCount) {
    return null;
  }

  if (info.url) {
    return (
      <Link
        className={styles['cell']}
        href={info.url}
        target="_blank"
        rel="nofollow noopener"
        onClick={() => Analytics.trackClickJK('flats')}
      >
        {`${info.offersCount} ${plural(info.offersCount, ['квартира', 'квартиры', 'квартир'])}`}
      </Link>
    );
  }

  return <span className={styles['cell']}>{info.offersCount}</span>;
}
